module.exports = __webpack_public_path__ + "static/img/pic2.c2b00bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/pic2.jpg
// module id = Gn84
// module chunks = 0